
export enum EnumTipoPesquisaFrente {
  Modular = 'Modular',
  Frentes = 'Frentes',
}
